// extracted by mini-css-extract-plugin
module.exports = {"inputTag":"input_inputTag__1AS4w"};